import script from "./NameyunDDns.vue?vue&type=script&setup=true&lang=js"
export * from "./NameyunDDns.vue?vue&type=script&setup=true&lang=js"

import "./NameyunDDns.vue?vue&type=style&index=0&id=7c78f07f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c78f07f"]])

export default __exports__